import type { AppDefinition } from '../../types/apps';

export const transcriptAppDefinition: AppDefinition = {
  appId: 'transcript',
  name: 'Transcripts',
  version: '1.0.0',
  description: 'Record meetings from computer audio, auto-transcribe, and review summaries, action items, and entity mentions.',

  entityTypes: ['Transcript'],
  requiresEntity: false,
  requiresProps: false,

  component: 'transcript',

  icon: {
    type: 'phosphor' as const,
    phosphorIcon: 'Microphone',
    phosphorWeight: 'duotone' as const,
    color: '#6366f1',
    metadata: {
      source: 'app' as const,
      appId: 'transcript',
      isAppIcon: true,
    },
  },

  searchableSkeletonFields: {
    Transcript: ['summary', 'markdown', 'keyPoints', 'decisions'],
  },

  agenticToolIds: ['transcript_create', 'transcript_read'],

  features: ['entityExtraction', 'audioPlayback', 'mentionTimeline', 'liveRecording', 'meetingSummary'],
  category: 'ai',
  isCore: false,
  isSystem: true,
  experimental: true,
};

export default transcriptAppDefinition;
